import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { PageHeader } from '@/components/dashboard/page-header';
import { InboxList } from '@/components/notifications/inbox-list';

export const Route = createFileRoute('/_app/notifications')({
  component: NotificationsPage,
});

function NotificationsPage(): React.ReactElement {
  return (
    <>
      <PageHeader title="Notifications" subtitle="Toutes vos notifications en un seul endroit." />
      <InboxList />
    </>
  );
}
